export type CropArea = {
    width: number
    height: number
    x: number
    y: number
}

const createImage = (url: string): Promise<HTMLImageElement> =>
    new Promise((resolve, reject) => {
        const image = new Image()
        image.addEventListener('load', () => resolve(image))
        image.addEventListener('error', (error) => reject(error))
        image.setAttribute('crossOrigin', 'anonymous')
        image.src = url
    })

export const getCroppedLogoBlob = async (
    imageSrc: string,
    croppedAreaPixels: CropArea,
    outputSize = 145,
    outputType: 'image/png' | 'image/jpeg' = 'image/png'
): Promise<Blob> => {
    const image = await createImage(imageSrc)

    const canvas = document.createElement('canvas')
    canvas.width = outputSize
    canvas.height = outputSize

    const ctx = canvas.getContext('2d')
    if (!ctx) {
        throw new Error('Canvas context not available')
    }

    ctx.clearRect(0, 0, outputSize, outputSize)

    // Если нужен прозрачный круглый PNG
    ctx.save()
    ctx.beginPath()
    ctx.arc(outputSize / 2, outputSize / 2, outputSize / 2, 0, Math.PI * 2)
    ctx.closePath()
    ctx.clip()

    ctx.drawImage(
        image,
        croppedAreaPixels.x,
        croppedAreaPixels.y,
        croppedAreaPixels.width,
        croppedAreaPixels.height,
        0,
        0,
        outputSize,
        outputSize
    )

    ctx.restore()

    return new Promise((resolve, reject) => {
        canvas.toBlob(
            (blob) => {
                if (!blob) {
                    reject(new Error('Canvas is empty'))
                    return
                }
                resolve(blob)
            },
            outputType,
            0.95
        )
    })
}
